import { render, staticRenderFns } from "./AnswerItem.vue?vue&type=template&id=29b92f4c&"
import script from "./AnswerItem.vue?vue&type=script&lang=js&"
export * from "./AnswerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports